import buttons from './orders/buttons';
import view from './orders/view';
import events from './orders/events';
import filters from './orders/filters';
import list from './orders/list';
import print from './orders/print';
import products from './orders/products';
import test from './orders/test';
import modals from '@/locales/kk/orders/modals';

export default {
    acceptanceActsFields: {
        orderId: 'Номер заказа',
        number: 'Номер АПП',
        dateFormed: 'Дата и время печати',
        deliveryServiceType: 'Служба доставки',
        initiator: 'Инициатор',
    },

    buttons,

    events,

    filters,

    list,

    print,

    products,

    tare: {
        title: 'Упаковочная тара',
        column1: 'Тип тары',
        column2: 'Вес, кг',
        textDanger: '(Не используется)',
        alert: 'Необходимо указать вес для каждой упаковочной тары!',
        maxWeight: 'Вес короба превысил допустимый вес курьерской службы. Максимально допустимый вес {max} кг. Отменить текущую упаковку?',
    },

    test,

    view,

    createRefund: 'Инициировать возврат ДС',

    item: {
        label: 'Изменения согласованы',
        confirm: 'Вы уверены что хотите изменить статус заказа?',
    },

    viewTitle: 'Заказ № {id}',

    modals,
};